import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 14a6 2 0 1 0 12 0a6 2 0 1 0 -12 0","key":"svg-0"}],["path",{"d":"M3 14v5c0 1.105 2.686 2 6 2s6 -.895 6 -2v-5","key":"svg-1"}],["path",{"d":"M9 5a6 2 0 1 0 12 0a6 2 0 1 0 -12 0","key":"svg-2"}],["path",{"d":"M9 5v3","key":"svg-3"}],["path",{"d":"M18.365 11.656c1.59 -.36 2.635 -.966 2.635 -1.656v-5","key":"svg-4"}]]

const IconCredits = createReactComponent('outline', 'credits', 'Credits', __iconNode);

export default IconCredits;